import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("fs_token");
export const setToken = (t) => localStorage.setItem("fs_token", t);
export const clearToken = () => localStorage.removeItem("fs_token");

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const imageUrl = (path, w) =>
  path
    ? `${API}/files/${path}?auth=${encodeURIComponent(getToken() || "")}${w ? `&w=${w}` : ""}`
    : null;
